export const usageConstants = {
    GET_USAGE_START: "GET_USAGE_START",
    GET_USAGE_SUCCESS: "GET_USAGE_SUCCESS",
    GET_USAGE_FAILURE: "GET_USAGE_FAILURE",
  };
  